import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import homeImage from '../../../assets/images/Login/homeImg.svg?url';
import AppQRCode from '../../../components/AppQRCode';
import styles from './index.module.scss';

function QRCodeContent({ mobileUrl }: { mobileUrl?: string }) {
  return (
    <div
      className={classNames(
        styles.contentDataContainer,
        styles.QRDataContainer,
        'flex flex-col text-base font-normal text-neutrals-n-400 w-1/2 items-start pr-4',
      )}
    >
      <div>
        To measure your patients and manage your virtual clinic on your mobile device download the{' '}
        <span className="font-bold text-secondary-s-500">OneStep mobile app</span> by
        scanning the QR code with your phone camera.
      </div>
      <div className={styles.qrContent}>
        <div className={styles.imgContainer}>
          <img src={homeImage} alt="homeImage" />
        </div>
        {mobileUrl ? (
          <AppQRCode qrCode={mobileUrl} width={180} wrapperClassName={styles.qrCanvas} />
        ) : null}
      </div>
    </div>
  );
}
export default observer(QRCodeContent);
